module.exports = __webpack_public_path__ + "img/2022_09_dandelion_square_fin_web.5a0c38ae.jpg";